module.exports = __webpack_public_path__ + "static/media/mordida.9ab2391f.svg";